/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import * as Theme from '@styles/theme-const'
import { ElementSizeType } from '@styles/theme-const'
import Button from '@shared/Button/Button'
import * as S from './BasketGoodPriceAndChanger.styled'
import BasketGoodPriceDescription from './BasketGoodPriceDescription/BasketGoodPriceDescription'
import { FavoriteIndicateMobile } from 'src/features/favorite/ui/favorite-indicate-mobile'
import { ChangerGood } from 'src/features/add-basket/changer-good'
import { useDeleteBasketItem } from '@entities/basket/hooks'
import { useIsDelivery } from 'src/pages/order/basket/hooks'

const BasketGoodPriceAndChanger = ({ good, shipment }) => {
    const isDelivery = useIsDelivery()
    const colorsButtonText = {
        color: Theme.ColorConsts.white,
        backgroundColor: Theme.ColorConsts.getRedheadColor(0.5)
    }
    const deleteConfirmationGoodId = useDeleteBasketItem()
    // const hiddenBasketItem = useHiddenBasketItem()
    // const visibleBasketItem = useVisibleBasketItem()
    // noinspection JSCheckFunctionSignatures
    const deleteBasketPosition = () => deleteConfirmationGoodId(good.webData.goodId)

    const isNotShowDeletes =
        (!isDelivery && good.isAvailableOnStock && good.stockPrice.normal) ||
        (isDelivery && good.deliveryStatus?.isAvailableForDelivery && good.deliveryPrice.normal) ||
        (isDelivery && good.isAvailableDeliveryByErecipe)

    // noinspection JSValidateTypes
    return (
        <S.Container>
            <BasketGoodPriceDescription good={good} isSelectedStock={!!shipment.stockId} />
            <S.BottomBlock>
                <FavoriteIndicateMobile goodId={good.webData.goodId} />
                {isNotShowDeletes && good.isAvailable ? (
                    <ChangerGood>{good}</ChangerGood>
                ) : (
                    <Button
                        data-basket-delete
                        colors={colorsButtonText}
                        elementSizeTypeValue={ElementSizeType.regular}
                        clickHandler={deleteBasketPosition}>
                        Удалить
                    </Button>
                )}
            </S.BottomBlock>
        </S.Container>
    )
}

BasketGoodPriceAndChanger.propTypes = {}

export default BasketGoodPriceAndChanger
